import { Fetch, useAuth } from '@polvo-labs/react-auth'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../components/Button'
import CompanyContainer from '../../components/CompanyContainer'
import Loader from '../../components/Loader'
import TestimonialContainer from '../../components/TestimonialContainer'
import Text from '../../components/Text'
import routes from '../../config/routes'
import CompanyGroup from '../../models/CompanyModel'
import TestimonialGroup from '../../models/FeedbackModel'
import isCommon from '../../utils/is-common'
import { Banner, Container, Tile, TileIcon } from './styles'


const HomeScreen = () => {
  const history = useHistory()
  const { authenticated, user } = useAuth()
  const [feedbackUrl] = useState(`${process.env.REACT_APP_API_URL}/comments`)
  const [midiaUrl] = useState(`${process.env.REACT_APP_API_URL}/articles`)
  const videoRef = React.createRef<HTMLVideoElement>()
  const [showVideoButton, setShowVideoButton] = useState<boolean>(true)
  const videoUrl = process.env.REACT_APP_ENV === 'local' ? '/assets/iptu_cover_web.mp4' : 'https://cdn.iptu.app/assets/vids/slide3.mp4'
  const videoQemUrl = process.env.REACT_APP_ENV === 'local' ? '/assets/qem_somos_video.mp4' : 'https://cdn.iptu.app/assets/vids/viceo_c6.mp4'
  const videoPreview= process.env.REACT_APP_ENV === 'local' ? '/assets/video_preview.png' : 'https://cdn.iptu.app/assets/img/video_preview.png'
  
  const playVideo = (evt: any) => {
    (videoRef as any).current.play()
    setShowVideoButton(false)
  }
  return (
    <div>
      <Banner>
        <Text
          style={{
            zIndex: '10',
            position: 'absolute',
            top: '35%',
            color: 'lightblue',
          }}
          tag="h2"
        >
          Seu imóvel tem dívida ativa de IPTU?
        </Text>
        <Text
          style={{
            zIndex: '10',
            position: 'absolute',
            top: 'calc(37% + 40px)',
          }}
          tag="h2"
          color="white"
        >
          Quer vender? Nós compramos!
        </Text>

        {(!user || isCommon(user)) && (
          <Button
            style={{
              zIndex: 10,
              position: 'absolute',
              top: 'calc(37% + 60px)',
            }}
            label="Cadastrar imóvel com dívida"
            backgroundColor="blue"
            onClick={() => {
              if (authenticated) {
                history.push(routes.realty.create.path)
              } else {
                history.push(routes.login.path)
              }
            }}
          />
        )}
        <video
          muted
          autoPlay
          loop
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      </Banner>

      <Text
        tag="h1"
        color="darkGray"
      >
        Quem somos
      </Text>

      <Container
        style={{ marginBottom: '85px', }}
      >
        <Tile
          style={{
            marginLeft: '0px',
            paddingLeft: '0px',
            marginBottom: '30px',
            marginTop: '22px',
            alignItems: 'flex-start'
          }}
        >
          <Text
            tag="p"
            style={{
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '19px',
              textAlign: 'left',
              marginTop: '10px',
              marginLeft: '0px',
            }}
          >
            Somos uma empresa com amplo conhecimento sobre as dificuldades existentes no mercado imobiliário.<br /><br />

            Sabemos que o acúmulo de débitos de imposto sobre os imóveis, geralmente acarreta a perda da propriedade em favor dos Municípios.<br /><br />

            Dessa forma, nosso objetivo é facilitar a compra do seu imóvel com relevantes débitos de imposto (dívida ativa).<br /><br />

            Então, se você deseja vender o seu imóvel com dívida ativa, realize seu cadastro e entre em contato conosco.
          </Text>
        </Tile>
        <Tile
          style={{ position: 'relative', marginTop: '17px' }}
        >
          <div>
            <video
              loop
              controls={!showVideoButton}
              ref={videoRef}
              style={{ maxWidth: '512px', width: '100%' }}
              poster={videoPreview}
            >
              <source src={videoQemUrl} type="video/mp4" />
            </video>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
              }}
              id="playVideo"
            >
              <img src="/assets/icon_play.svg"
                alt="Play video"
                hidden={!showVideoButton}
                onClick={playVideo}
              />
            </div>
          </div>
        </Tile>
      </Container>

      <Text
        tag="h1"
        color="darkGray"
      >
        Principais vantagens
      </Text>

      <Container
        style={{ marginTop: '32px', marginBottom: '32px' }}
      >
        <Tile>
          <TileIcon
            name="money"
          />
          <Text
            tag="h2"
            color="darkGray"
          >
            Adiantamento financeiro
          </Text>
          <Text
            tag="p"
            style={{ textAlign: 'center' }}
          >
            Vendendo seu imóvel em dívida ativa você obtém retorno financeiro mais rápido.
          </Text>
        </Tile>

        <Tile>
          <TileIcon
            name="message"
          />
          <Text
            tag="h2"
            color="darkGray"
          >
            Livre de dívidas
          </Text>
          <Text
            tag="p"
            style={{ textAlign: 'center' }}
          >
            As dívidas do seu imóvel não impediram a compra dele, o IPTU Dívida Ativa paga os débitos, deixando você livre de dívidas.
          </Text>
        </Tile>

        <Tile>
          <TileIcon
            name="page"
          />
          <Text
            tag="h2"
            color="darkGray"
          >
            Equipe Jurídica especializada
          </Text>
          <Text
            tag="p"
            style={{ textAlign: 'center' }}
          >
            O atendimento via chat é feito por uma equipe jurídica especializada, que estará disponível para tirar quaisquer dúvidas sem custo algum.
          </Text>
        </Tile>
      </Container>

      <Text
        style={{ marginBottom: '28px', display: 'none' }}
        tag="h1"
        color="darkGray"
      >
        Feedback dos nossos usuários
      </Text>
      <Fetch
        url={feedbackUrl}
        loader={() => (
          <Loader darkMode />
        )}
      >
        {({ data }) => data && data.data ? (
          <div style={{ display: 'none' }}>
            <TestimonialContainer testimonials={data.data as TestimonialGroup[]} />
          </div>

        ) : (
            <span>Error</span>
          )}
      </Fetch>

      <Text
        style={{ marginBottom: '28px', display: 'none' }}
        tag="h1"
        color="darkGray"
      >
        IPTU na mídia
      </Text>

      <Fetch
        url={midiaUrl}
        loader={() => (
          <Loader darkMode />
        )}
      >
        {({ data }) => data && data.data ? (
          <div
            style={{ display: 'none' }}
          >
            <CompanyContainer
              companies={data.data as CompanyGroup[]} 
            />
          </div>

        ) : (
            <span>Error</span>
          )}
      </Fetch>
    </div >
  )
}

export default HomeScreen
